import React, { useMemo, useRef, useState } from 'react';

import { Breadcrumb, breadcrumbsContext, BreadcrumbsContext } from '../Breadcrumbs/BreadcrumbsContext';

interface IBreadcrumbsProviderProps {
  children: any;
}

export function BreadcrumbsProvider({ children }: IBreadcrumbsProviderProps) {
  const breadcrumbsContainerRef = useRef<HTMLDivElement>(null);
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);

  const value = useMemo(() => ({
    setBreadcrumbs: (setBreadcrumbs as BreadcrumbsContext['setBreadcrumbs']),
    breadcrumbs,
    breadcrumbsContainerRef,
  }), [breadcrumbs]);

  return (
    <breadcrumbsContext.Provider value={value}>
      {children}
    </breadcrumbsContext.Provider>
  );
}